export {default as MainC} from 'modules/registros/components/main';
export {default as LogsC} from 'modules/registros/components/logs';



// WEBPACK FOOTER //
// src/modules/registros/component.js